/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { GetAllPaylinksQueryFilters } from '../../../../store/modules/paylink/types';
import { BaseFiltersPanel } from '../BaseFiltersPanel';
import { PaylinkFilters } from './PaylinkFillters';
import {
  PaylinkFiltersFormValues,
  paylinkFiltersFormValuesToApiFilters,
  usePaylinkFiltersForm,
  paylinkFiltersEmptyValues,
} from '../../../../hooks/usePaylinkFiltersForm';
interface Props {
  merchantId: string;
  isOpen: boolean;
  onClose: () => void;
  onFiltersApply: (filters: GetAllPaylinksQueryFilters) => void;
  initialFilterState?: Partial<PaylinkFiltersFormValues>;
}

export const PaylinkFiltersPanel = ({
  isOpen,
  onClose,
  merchantId,
  onFiltersApply,
  initialFilterState = {},
}: Props) => {
  const { paylinkPaymentMethodFilter } = useFlags();
  const [lastApplied, setLastApplied] = useState({
    ...paylinkFiltersEmptyValues,
    ...initialFilterState,
  });

  const {
    control,
    formState: { errors },
    setValue,
    watch,
    reset,
    handleSubmit,
  } = usePaylinkFiltersForm({
    initialValues: initialFilterState,
  });

  const onSubmit = (data: PaylinkFiltersFormValues) => {
    onFiltersApply(paylinkFiltersFormValuesToApiFilters(data, paylinkPaymentMethodFilter));
    setLastApplied(data);
    onClose();
  };

  const onCancel = () => {
    reset(lastApplied);
    onClose();
  };

  return (
    <BaseFiltersPanel
      isOpen={isOpen}
      onCancel={onCancel}
      onReset={() => reset(paylinkFiltersEmptyValues)}
      onSubmit={handleSubmit(onSubmit)}
      filtersCount={
        Object.keys(paylinkFiltersFormValuesToApiFilters(watch(), paylinkPaymentMethodFilter))
          .length
      }
    >
      <PaylinkFilters
        merchantId={merchantId}
        showTransactionDateRange
        hookFormProps={{
          watch,
          setValue,
          control,
          errors,
        }}
      />
    </BaseFiltersPanel>
  );
};
